var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.topright",modifiers:{"hover":true,"topright":true}}],attrs:{"variant":"outline-primary","size":"sm","title":_vm.tooltip},on:{"click":_vm.changeSecretNoInput}},[_c('b-icon',{attrs:{"animation":_vm.isSpinEnabled ? 'spin' : '',"icon":"arrow-clockwise"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }